import { addStateReset } from "common/reducer/addStateReset";
import { hardNavigate } from "common/utilities/hardNavigate";
import { useSelector } from "common/utilities/react-redux";
import { useWeforumUrl } from "common/utilities/useWeforumUrl";
import { AuthenticationType } from "domains/authentication/actionTypes";
import { getUserRole } from "domains/authentication/selectors";
import { UserRole } from "entities/permissions/constants";

export const addUserChangeReset = addStateReset(AuthenticationType.LOGOUT);

export const useGoToMembership = () => {
  const userRole = useSelector(getUserRole);
  const weforumUrl = useWeforumUrl();

  return () =>
    hardNavigate(
      userRole === "Unauthenticated" || UserRole.Public
        ? `${weforumUrl}/join-us/pricing`
        : `${import.meta.env.VITE_MY_FORUM_URL}/membership`,
    );
};
